<template>
    <div class="org-manage-wrap">
      <!-- 查询筛选 -->
      <div class="search-card">
        <el-form :model="queryForm" inline>
          <el-form-item label="机构名称">
            <el-input
              v-model="queryForm.orgName"
              placeholder="请输入机构名称"
              clearable
            />
          </el-form-item>
          <el-form-item label="机构状态">
            <el-select v-model="queryForm.orgStatus" placeholder="全部" clearable style="width:140px">
              <el-option label="全部" value="" />
              <el-option label="启用" :value="1" />
              <el-option label="禁用" :value="0" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
            <el-button type="success" @click="openAddOrgDialog">新增机构</el-button>
          </el-form-item>
        </el-form>
      </div>
  
      <!-- 表格 -->
      <div class="table-card">
        <el-table
          :data="tableData"
          border
          stripe
          v-loading="loading"
          style="width:100%"
        >
          <el-table-column label="机构ID" prop="orgId" align="center" width="120" />
          <el-table-column label="机构名称" prop="orgName" align="center" min-width="220" />
          <el-table-column label="法人姓名" prop="contactPerson" align="center" width="130" />
          <el-table-column label="联系电话" prop="contactPhone" align="center" width="140" />
          <el-table-column label="账户余额" align="center" width="140">
            <template #default="scope">
              <div>¥{{ scope.row.available_balance ?? 0 }}</div>
              <div style="font-size:12px;color:#909399">冻结：¥{{ scope.row.frozen_amount ?? 0 }}</div>
            </template>
          </el-table-column>
          <el-table-column label="子账号数量" prop="subAccountNum" align="center" width="120" />
          <el-table-column label="机构状态" align="center" width="120">
            <template #default="scope">
              <el-switch
                v-model="scope.row.orgStatus"
                :active-value="1"
                :inactive-value="0"
                @change="handleSwitchStatus(scope.row)"
              />
              <span class="ml-2">
                {{ scope.row.orgStatus === 1 ? "启用" : "禁用" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="160">
            <template #default="scope">
              <el-button type="primary" link @click="openSubAccountDialog(scope.row)">
                查看子账号
              </el-button>
            </template>
          </el-table-column>
        </el-table>
  
        <el-pagination
          v-model:current-page="pagination.page"
          v-model:page-size="pagination.pageSize"
          :total="pagination.total"
          :page-sizes="[10,20,50,100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="getmainlistdata"
          @current-change="getmainlistdata"
          class="mt-4"
        />
      </div>
  
      <!-- 新增机构弹窗 -->
      <el-dialog
        v-model="addOrgDialogVisible"
        title="新增一级机构"
        width="520px"
        :close-on-click-modal="false"
      >
        <el-form
          ref="addOrgFormRef"
          :model="addOrgForm"
          :rules="addOrgRules"
          label-width="100px"
        >
          <el-form-item label="机构名称" prop="orgName">
            <el-input v-model="addOrgForm.orgName" placeholder="请输入机构名称" />
          </el-form-item>
          <el-form-item label="联系人" prop="contactPerson">
            <el-input v-model="addOrgForm.contactPerson" placeholder="请输入联系人姓名" />
          </el-form-item>
          <el-form-item label="联系电话" prop="contactPhone">
            <el-input v-model="addOrgForm.contactPhone" placeholder="请输入手机号码" />
          </el-form-item>
          <el-form-item label="初始状态" prop="orgStatus">
            <el-radio-group v-model="addOrgForm.orgStatus">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="addOrgDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="submitLoading" @click="submitAddOrg">确认提交</el-button>
        </template>
      </el-dialog>
  
      <!-- 子账号详情弹窗 -->
      <el-dialog
        v-model="subDialogVisible"
        title="机构子账号列表"
        width="920px"
        :close-on-click-modal="false"
        v-loading="subLoading"
        @close="onSubDialogClose"
      >
        <div class="mb-3 text-base">
          当前机构：<span class="font-bold">{{ currentOrg.orgName }}</span>
        </div>
        <div class="sub-search-bar mb-3">
          <el-input
            v-model="subQuery.name"
            placeholder="子账号姓名"
            clearable
            style="width:220px"
            @keyup.enter="fetchSubAccountList"
          />
          <el-button type="primary" @click="fetchSubAccountList">搜索</el-button>
          <el-button @click="resetSubQuery">重置</el-button>
        </div>
  
        <el-table :data="subAccountList" border stripe max-height="420">
          <el-table-column label="子账号ID" prop="id" align="center" width="100" />
          <el-table-column label="姓名" prop="name" align="center" width="120" />
          <el-table-column label="身份证号" prop="cardid" align="center" min-width="180" />
          <el-table-column label="手机号" prop="mobile" align="center" width="140" />
          <el-table-column label="邮箱" prop="email" align="center" min-width="180" />
          <el-table-column label="子账号余额" align="center" width="140">
            <template #default="scope">
              <div>¥{{ scope.row.available_balance ?? 0 }}</div>
              <div style="font-size:12px;color:#909399">冻结：¥{{ scope.row.frozen_amount ?? 0 }}</div>
            </template>
          </el-table-column>
          <el-table-column label="账号状态" align="center" width="110">
            <template #default="scope">
              <el-tag :type="scope.row.iam_static ===1 ? 'success':'danger'">
                {{ scope.row.iam_static ===1 ? "正常":"禁用" }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
  
        <el-pagination
          v-model:current-page="subPagination.page"
          v-model:page-size="subPagination.pageSize"
          :total="subPagination.total"
          :page-sizes="[10,20]"
          layout="total, prev, pager, next"
          @current-change="fetchSubAccountList"
          @size-change="fetchSubAccountList"
          class="mt-4"
        />
  
        <template #footer>
          <el-button @click="subDialogVisible = false">关闭</el-button>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script setup>
  import { ref, reactive, onMounted } from "vue";
  import { ElMessage, ElMessageBox } from "element-plus";
  import { getmainlist, getiamlist } from "@/api/api";
  
  const loading = ref(false);
  const submitLoading = ref(false);
  const subLoading = ref(false);
  const queryForm = reactive({
    orgName: "",
    orgStatus: "",
  });
  
  const pagination = reactive({
    page: 1,
    pageSize: 10,
    total: 0,
  });
  
  const tableData = ref([]);
  
  //新增机构弹窗
  const addOrgDialogVisible = ref(false);
  const addOrgFormRef = ref(null);
  const addOrgForm = reactive({
    orgName: "",
    contactPerson: "",
    contactPhone: "",
    orgStatus: 1,
  });
  const addOrgRules = {
    orgName: [
      { required: true, message: "请输入机构名称", trigger: "blur" }
    ],
    contactPerson: [
      { required: true, message: "请输入联系人", trigger: "blur" }
    ],
    contactPhone: [
      { required: true, message: "请输入联系电话", trigger: "blur" },
      { pattern: /^1[3-9]\d{9}$/, message: "手机号格式不正确", trigger: "blur" }
    ],
    orgStatus: [
      { required: true, message: "请选择初始状态", trigger: "change" }
    ]
  };
  
  //子账号弹窗
  const subDialogVisible = ref(false);
  const currentOrg = ref({});
  const subAccountList = ref([]);
  const subQuery = reactive({
    name: ""
  });
  const subPagination = reactive({
    page: 1,
    pageSize: 10,
    total: 0
  });
  
  // 获取主机构列表（对接 getmainlist）
  const getmainlistdata = async () => {
    loading.value = true;
    try {
      const params = {
        page: pagination.page,
        pageSize: pagination.pageSize,
        name: queryForm.orgName || undefined,
        company_static: queryForm.orgStatus !== "" ? queryForm.orgStatus : undefined,
      };
      const res = await getmainlist(params);
      if (res.code === 200) {
        tableData.value = res.data.list.map(item => {
          return {
            orgId: item.id,
            orgName: item.company_name,
            contactPerson: item.legal_name,
            contactPhone: item.company_mobile,
            orgStatus: item.company_static,
            available_balance: item.available_balance,
            frozen_amount: item.frozen_amount,
            subAccountNum: 0,
            raw: item
          };
        });
        pagination.total = res.data.total;
      }
    } catch (err) {
      ElMessage.error("获取机构列表失败");
    } finally {
      loading.value = false;
    }
  };
  
  //切换机构启用禁用状态
  const handleSwitchStatus = async (row) => {
    ElMessageBox.confirm(
      row.orgStatus === 1 ? "确认启用该机构？" : "确认禁用该机构，禁用后该机构下所有子账号将不可使用？",
      "提示",
      { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" }
    ).then(async () => {
      // todo:替换真实修改状态接口
      ElMessage.success("状态修改成功");
      getmainlistdata();
    }).catch(() => {
      row.orgStatus = row.orgStatus === 1 ? 0 : 1;
    })
  };
  
  //打开新增弹窗，重置表单
  const openAddOrgDialog = () => {
    addOrgDialogVisible.value = true;
    addOrgFormRef.value?.resetFields();
  };
  
  //提交新增机构
  const submitAddOrg = async () => {
    await addOrgFormRef.value.validate();
    submitLoading.value = true;
    try {
      // todo:替换真实新增机构api
      ElMessage.success("新增机构成功");
      addOrgDialogVisible.value = false;
      getmainlistdata();
    } catch (err) {
      ElMessage.error("新增机构失败");
    } finally {
      submitLoading.value = false;
    }
  };
  
  //打开子账号弹窗
  const openSubAccountDialog = (row) => {
    currentOrg.value = row;
    subQuery.name = "";
    subPagination.page = 1;
    subDialogVisible.value = true;
    fetchSubAccountList();
  };
  
  //拉取子账号列表 getiamlist
  const fetchSubAccountList = async () => {
    subLoading.value = true;
    try {
      const params = {
        page: subPagination.page,
        pageSize: subPagination.pageSize,
        name: subQuery.name || undefined,
        companyid: currentOrg.value.orgId
      };
      const res = await getiamlist(params);
      if (res.code === 200) {
        subAccountList.value = res.data.list;
        subPagination.total = res.data.total;
      }
    } catch (e) {
      ElMessage.error("获取子账号列表失败");
    } finally {
      subLoading.value = false;
    }
  };
  
  const resetSubQuery = () => {
    subQuery.name = "";
    subPagination.page = 1;
    fetchSubAccountList();
  };
  
  const onSubDialogClose = () => {
    subAccountList.value = [];
    subPagination.page = 1;
    subPagination.total = 0;
  };
  
  const handleSearch = () => {
    pagination.page = 1;
    getmainlistdata();
  };
  
  const handleReset = () => {
    queryForm.orgName = "";
    queryForm.orgStatus = "";
    pagination.page = 1;
    getmainlistdata();
  };
  
  onMounted(() => {
    getmainlistdata();
  })
  </script>
  
  <style scoped>
  .org-manage-wrap {
  }
  .search-card {
    background: #fff;
    padding: 16px;
    border-radius: 6px;
    margin-bottom: 16px;
  }
  .table-card {
    background: #fff;
    padding: 16px;
    border-radius: 6px;
  }
  .mt-4 {
    margin-top: 16px;
  }
  .ml-2 {
    margin-left: 8px;
  }
  .mb-3 {
    margin-bottom: 12px;
  }
  .font-bold {
    font-weight: bold;
  }
  .text-base {
    font-size: 14px;
  }
  .sub-search-bar {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  </style>
  